import React from "react";
import { View, Text } from "@react-pdf/renderer";
import { makePdfStyleSheet } from "./../styles";
import PDFTag from "ui/components/PDF/components/Tag";

export type PDFTableTitleRowVariant =
  | "primary"
  | "rowLike"
  | "primaryBorderedBottom"
  | "invisible";
export interface PDFTableTitleRowProps {
  variant?: PDFTableTitleRowVariant;
  columns: {
    title: string;
    width?: number | string;
    flex?: number;
    color?: string;
    fontStyle?: string;
  }[];
  tags?: string[];
}

function PDFTableTitleRow({
  columns,
  variant = "primary",
  tags,
}: PDFTableTitleRowProps) {
  const styles = makePdfStyleSheet({
    tableTitleRow: {
      variant,
    },
  });

  const getCellStyle = (column: {
    width?: number | string;
    flex?: number;
    color?: string;
    fontStyle?: string;
    paddingHorizontal?: number;
  }) =>
    makePdfStyleSheet({
      tableTitleRow: {
        variant,
      },
      tableTitleRowCell: column,
    }).tableTitleRowCell;

  return (
    <>
      {tags?.length ? (
        <View style={[styles.flexRow, styles.tableTitleRow]}>
          {tags.map((tag, index) => (
            <View style={{ marginRight: 4 }}>
              <PDFTag text={tag} key={index} />
            </View>
          ))}
        </View>
      ) : null}
      <View style={[styles.flexRow, styles.tableTitleRow]}>
        {columns.map((column, index) => (
          <View style={getCellStyle(column)} key={index}>
            <Text>{column.title}</Text>
          </View>
        ))}
      </View>
    </>
  );
}

export default PDFTableTitleRow;
